// app/features/ai-workflows/services_and_hooks/paginatedUseCasesPolling.ts

export function paginatedUseCasesRefetchInterval(
  usePollingFallback: boolean,
  rows: { generation_status?: string | null }[] | undefined,
): number | false {
  if (!usePollingFallback || !rows) return false;
  const hasGenerating = rows.some((useCase) => {
    const status = useCase.generation_status;
    return Boolean(status && !["completed", "failed"].includes(status));
  });
  return hasGenerating ? 3000 : false;
}
